export default "__VITE_ASSET__xjGRgXln__"